import { generateScope } from "../../logic/generation/generateScope";
import parseTemplate from "../../logic/templating/parseTemplate";
import generateScaffoldedParts from "../../logic/templating/scaffolding/generateScaffoldedParts";
import { TemplatePartTypes } from "../../logic/templating/types";
import { Content, ContentSource } from "../types";

export function generateContent({
  source: {
    questionTemplate,
    markSchemeTemplate,
    answersTemplate,
    generationScript,
    calculatorEnabled,
    imageLabels,
    validationScript,
    imageUrl,
    generationSeed
  },
  generateScaffolding
}: {
  source: ContentSource;
  generateScaffolding: boolean;
}): Content {
  const scope = generateScope(generationScript, generationSeed);

  const [questionParts, markSchemeParts, answerParts] = [
    questionTemplate,
    markSchemeTemplate,
    answersTemplate
  ].map(it => parseTemplate(scope, it || ""));

  const scaffoldedParts = generateScaffolding
    ? generateScaffoldedParts(scope, markSchemeParts)
    : [];

  const processedImageLabels = imageLabels?.map(label => ({
    ...label,
    originalParts: parseTemplate(scope, label.template, false),
    evaluatedParts: parseTemplate(scope, label.template, true)
  }));

  const maxScore = answerParts.filter(
    it => it.type === TemplatePartTypes.INPUT
  ).length;

  return {
    calculatorEnabled: calculatorEnabled ?? true,
    questionParts,
    markSchemeParts,
    scaffoldedParts,
    answerParts,
    validationScript,
    scope,
    maxScore,
    imageUrl,
    imageLabels: processedImageLabels || []
  };
}
